import { validateArguments } from '../../SignatureValidation';
export var VarFn;
(function (VarFn) {
    VarFn.Name = `VAR`;
    VarFn.Stage = "AGGREGATE";
    VarFn.Signature = `VAR(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: VarFn.Name,
            stage: VarFn.Stage,
            data: { type, role },
        };
    }
    VarFn.make = make;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: { name: VarFn.Name, signature: VarFn.Signature, location: callNode.location },
            arguments: [
                {
                    type: "NUMERIC",
                    stages: ["CONST", "SCALAR"],
                },
            ],
        }, args);
    }
    VarFn.validate = validate;
})(VarFn || (VarFn = {}));
